import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { CountryService } from 'src/app/core/services/country.service';
import { LoginService } from 'src/app/core/services/login.service';
import { VerticalSolutionsService } from 'src/app/core/services/verticalsolutions.service';
import { VerticalSolution } from 'src/app/model/vertical-solutions';
import { ProductDto } from 'src/app/model/ProductDto';
import { ActivatedRoute } from '@angular/router';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CustomerService } from 'src/app/core/services/customer.service';
import { YesNoDialogComponent } from 'src/app/store/dialogs/yes-no-dialog/yes-no-dialog.component';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { Validators, FormControl } from '@angular/forms';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';


@Component({
    selector: 'ms-insert-new-solution',
    templateUrl: './insert-new-solution.component.html',
    styleUrls: ['./insert-new-solution.component.scss'],
})
export class InsertNewSolutionComponent implements OnInit {
    public cmsObj: CmsObject[];
    @ViewChild(NgForm) mainDataForm: NgForm;
    activationServiceIntro: string = '';
    messageBoxMessage: string = '';
    restactivationintroduction: string = '';
    wseactivationintroduction: string = '';
    newkeyintroduction: string = '';
    modifykeyintroduction: string = '';
    servicedataintroduction: string = '';
    isError: boolean;
    isNewActivation: boolean = false;
    isOldActivation: boolean = false;
    checkedActivationWSE: boolean = false;
    checkedActivationAPIRest: boolean = false;
    keyCreated: boolean = true;
    editMode: boolean = false;
    showMessage: boolean = false;
    authorizationStored;
    isNew: boolean;
    productDto: ProductDto;
    vsPrivateKey: string;
    authorizationProperties: AuthorizationProperties;
    vs: VerticalSolution = new VerticalSolution();
    @ViewChild('wsUrl') private _inputElement: ElementRef;
    signatureControl: FormControl;
    descriptionControl: FormControl;
    public smallScreen: boolean = false;

    constructor(
        public cmsService: CmsService,
        public verticalSolutionService: VerticalSolutionsService,
        private loginService: LoginService,
        public navigateService: NavigateService,
        private countryService: CountryService,
        private route: ActivatedRoute,
        public dialog: MatDialog,
        private customerService: CustomerService,
        private variable: TranslatedVariables,
        public workFlow: WorkFlowService,
        private breakpointObserver: BreakpointObserver,
    ) {
        this.signatureControl = new FormControl('', [Validators.required, Validators.maxLength(50), this.noWhitespaceValidator]);
        this.descriptionControl = new FormControl('', [Validators.maxLength(64)]);
    }

    async ngOnInit() {
      this.breakpointObserver.observe(['(max-width: 900px)']).subscribe((state: BreakpointState) => {
        this.smallScreen = !state.matches;
    });
        this.getCmsObj();
        this.route.queryParams.subscribe((params) => {
            this.isNew = params.isNew;
            if (this.isNew) {
                this.productDto = new ProductDto('');
            } else {
                this.productDto = this.navigateService.getLocalStorageData<ProductDto>('selectedSolution');
                this.setVerticalSolutionInfo();
                console.log(this.productDto);
                this.editMode = true;
                this.signatureControl.disable();
                this.signatureControl.updateValueAndValidity();
                this.messageBoxMessage = '';
                this.isNewActivation = this.productDto.ActivationMode === 1;
                this.isOldActivation = this.productDto.ActivationMode === 2;
            }
        });
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        this.customerService.companyInfo$.subscribe(async (companyInfo) => {
            if (!companyInfo) return;
            let opResult = await this.verticalSolutionService.getKey(
                this.verticalSolutionService.currentCodiceAzienda,
                this.authorizationProperties.accountName
            );
            this.isError = !opResult.Result;
            if (!opResult.Result) {
                if (opResult.Code == -1) {
                    this.showMessage = true;
                    this.messageBoxMessage = opResult.Message;
                    this.keyCreated = false;
                }
                //else {
                //    this.keyCreated = false;
                //    this.showMessage = true;
                //    this.messageBoxMessage = opResult.Message;
                //}
            } else {
                this.showMessage = false;
                this.keyCreated = true;
            }
        });
    }

    async getCmsObj() {
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(this.workFlow.getLanguageForCms(), 'vs_insertmodifysolution');
        this.restactivationintroduction = this.cmsObj.find(
            (x) => x.ContentName == 'vs_insertmodifysolution.restactivationintroduction'
        ).ContentTranslation;
        this.wseactivationintroduction = this.cmsObj.find(
            (x) => x.ContentName == 'vs_insertmodifysolution.wseactivationintroduction'
        ).ContentTranslation;
        this.newkeyintroduction = this.cmsObj.find((x) => x.ContentName == 'vs_insertmodifysolution.newkeyintroduction').ContentTranslation;
        this.modifykeyintroduction = this.cmsObj.find(
            (x) => x.ContentName == 'vs_insertmodifysolution.modifykeyintroduction'
        ).ContentTranslation;
        this.activationServiceIntro = this.cmsObj.find(
          (x) => x.ContentName == 'vs_insertmodifysolution.activationServiceIntro'
      ).ContentTranslation;
    }
    webServiceActiveIsDisable() {
        return (
            this.productDto.WebServiceURL === '' || this.productDto.WebServiceURL === null || this.productDto.WebServiceURL === undefined
        );
    }
    webServiceUrlIsDisable() {
        return !this.isNewActivation && !this.isOldActivation;
    }
    public async onClickAttivationType(num: number) {
        switch (num) {
            case 1:
                this.isNewActivation = true;
                this.isOldActivation = false;
                this.productDto.ActivationMode = 1;
                return;
            case 2:
                this.isNewActivation = false;
                this.isOldActivation = true;
                this.productDto.ActivationMode = 2;
                return;
            default:
                this.isNewActivation = false;
                this.isOldActivation = false;
                this.productDto.ActivationMode = 0;
                return;
        }
    }

    isInvalid() {
        return (this.isNewActivation && !this.keyCreated) || this.signatureControl.invalid || this.descriptionControl.invalid;
    }
    getErrorSignatureMessage() {
        return this.signatureControl.hasError('required') ? this.variable.mandatoryField : this.variable.invalidInputMessage50Nowhitespace;
    }
    getErrorDescriptionMessage() {
        return this.variable.invalidInputMessage64;
    }
    noWhitespaceValidator(control: FormControl) {
        const isSpace = (control.value || '').match(/\s/g);
        return isSpace ? { whitespace: true } : null;
    }
    onValueChange(event: any) {
        this.productDto.Active = event.checked;
    }
    onValueChangeWS(event: any) {
        this.productDto.WebServiceUrlNotReliable = event.checked;
    }

    async createorUpdateVerticalSolution() {
        //
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        this.productDto.WebServiceURL = this._inputElement?.nativeElement.value;
        this.setVerticalSolutionInfo();
        let opResult = await this.verticalSolutionService.saveOrUpdateVerticalSolution(
            this.vs,
            this.isNew,
            this.authorizationProperties.accountName
        );
        this.showMessage = true;
        this.messageBoxMessage = opResult.Message;
        this.isError = !opResult.Result;
        if (opResult.Code == 3) {
            //private key non presente
            //mi restituisce il codice rivenditore generato
            this.vs.ResellerCode = opResult.Content;
        }
        if (opResult.Result) {
            this.workFlow.showSnackBar(this.isNew? this.variable.verticalSolutionsSaved: this.variable.verticalSolutionsModified);
            this.navigateService.goToVerticalSolutionManagement();
        }
    }

    setVerticalSolutionInfo() {
        this.vs.Signature = this.productDto.Signature;
        this.vs.Description = this.productDto.Description;
        this.vs.wsUrl = this.productDto.WebServiceURL;
        this.vs.ZucchettiCode = this.verticalSolutionService.currentCodiceAzienda;
        this.vs.ResellerCountry = this.countryService.resellerCountry;
        this.vs.ResellerCompanyName = this.verticalSolutionService.resellerCompanyName;
        this.vs.Active = this.productDto.Active;
        this.vs.wsNotActive = this.productDto.WebServiceUrlNotReliable;
        this.vs.IsWSRest = this.productDto.ActivationMode.toString();
    }

    async generateSolutionKey() {
        try {
            const dlgAsk = this.dialog.open(YesNoDialogComponent, {
                data: {
                    Title: this.variable.keyGeneration,
                    Message: this.variable.keyGenerationQuestion,
                    Result: true,
                },
            });

            dlgAsk.afterClosed().subscribe((resAskDlg) => {
                if (!resAskDlg) {
                    return;
                } else if (resAskDlg.Result) {
                    this.keyGeneration();
                    this.workFlow.showSnackBar(this.variable.keyGenerationOk);
                }
            });
        } catch (err) {
            alert('Error during generating key');
        }
    }

    async keyGeneration() {
        await this.createKey();
        this.writeContents(this.vsPrivateKey, 'Key' + '.txt', 'text/plain');
    }
    writeContents(content, fileName, contentType) {
        var a = document.createElement('a');
        var file = new Blob([content], { type: contentType });
        a.href = URL.createObjectURL(file);
        a.download = fileName;
        a.click();
    }
    async createKey() {
        this.setVerticalSolutionInfo();
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        let opResult = await this.verticalSolutionService.generateKeys(this.vs, this.authorizationProperties.accountName);
        this.keyCreated = opResult.Result;
        //this.showMessage = true;
        //this.messageBoxMessage = opResult.Message;
        this.vsPrivateKey = opResult.Content.toString();
        this.isError = !opResult.Result;
    }
}
